import React, { useEffect, useState } from 'react';
import righttick from "../images/greentick.png";
import bankimg from "../images/bank-img.png";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown, faLock, faRightFromBracket,faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { Box, CircularProgress } from "@mui/material";
import styled from "@emotion/styled";

export const PaymentsuccessPage = () => {
  const [paymentStatus, setPaymentStatus] = useState(null);

  const [activeItem, setActiveItem] = useState("Dashboard");
  const handleClick = (item) => {
    setActiveItem(item);
  };
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const orderid = urlSearchParams.get('orderid');

    const userDataFromStorage = localStorage.getItem('userData');
    const userData = JSON.parse(userDataFromStorage);

    if (userData?.token && orderid) {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${userData.token}`);

      const formdata = new FormData();
      formdata.append("orderid", orderid);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow"
      };

      fetch("https://api.ayyawinstudyfoundation.org/api/check/paymentstatus", requestOptions)
        .then(response => response.json())  // Parse the JSON response
        .then(result => {
          console.log(result.data);
          if (result.data && result.data.payment_status) {
            setPaymentStatus(result.data.payment_status);  // Set the payment status
          }
        })
        .catch(error => console.error("Error:", error));
    }
  }, []);
  const [showModal, setShowModal] = useState(false);
  const [showForm1Loader, setShowForm1Loader] = useState(false);

    const userDataFromStorage = localStorage.getItem('userData');

  const userData = JSON.parse(userDataFromStorage);
    const FullScreenOverlay = styled(Box)(({ theme }) => ({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    zIndex: 1300, // Higher than most other elements
  }));

    const handleLogout = (e) => {
    setShowModal(true);
  };
  const handleLogout2 = (e) => {
    setShowModal(false);
  };
  const handleLogout3 = (e) => {
    setShowForm1Loader(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${userData?.token}`);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: "", // Empty body as per your provided code
      redirect: "follow"
    };

    fetch("https://api.ayyawinstudyfoundation.org/api/admin/signout", requestOptions)
      .then(response => response.text())
      .then(result => {
        console.log(result);
        // Clear user data from local storage and close the modal
        localStorage.removeItem('userData');
        setShowModal(false);
        // Optionally, you can redirect the user to the login page
        window.location.href = "/signin";
      })
      .catch(error => {
        console.error('Error:', error);
        // Optionally, display an error message to the user
      });

  };

  return (
    <>
      <div className="container mx-auto taskpagecon mt-">
        <div>
          <div className="div">
            <a
              href="#"
              onClick={() => handleClick("Dashboard")}
              className={activeItem === "Dashboard" ? "taskpagehead" : "taskpagehead2"}
            >
              Dashboard
            </a>
            <a
              href="#"
              className={activeItem === "Tasks" ? "taskpagehead" : "taskpagehead2"}
            >
              Tasks
            </a>
            <a
              href="#"
              className={activeItem === "My account" ? "taskpagehead" : "taskpagehead2"}
            >
              My account
            </a>
             <a
              href="#"
              onClick={handleLogout}
              className="signout"
            >
              <FontAwesomeIcon icon={faRightFromBracket} style={{ color: "#fff", }} />
            </a>
          </div>
        </div>
      </div>
      {paymentStatus === "PROCESSING" && (
        <>
          <div className="block md:flex items-center justify-center">
            <div className="w-full md:w-2/6 mt-5 flex justify-center p-5 container mx-auto">
              <img src={bankimg} alt="" />
            </div>
            <div className="w-full md:w-3/5 p-0 md:p-10">
              <div className="taskcontent text-center p-5 container mx-auto rounded">
                <h3 className="text-2xl font-semibold mb-4">Processing Your Request</h3>
                <p className="mb-2">Please wait for our confirmation</p>
                <p className="text-sm text-gray-600">We appreciate your patience.</p>
                <p className="text-sm text-gray-600">If you have any questions, feel free to contact us.</p>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center">
            <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12"></div>
          </div>
        </>
      )}
      {paymentStatus === "SUCCESS" && (
        <>
<div className="min-h-screen succestick bg-green-100 flex items-center justify-center">
  <div className="bg-white p-10 rounded-lg shadow-lg max-w-md text-center">
    <img src={righttick} alt="Success" width="100px" className="mx-auto mb-4" />
    <h2 className="text-3xl font-bold text-green-700">Payment Successful!</h2>
    <p className="text-lg mt-4 text-gray-700">Your kit will arrive within 10 days.</p>
    <p className="text-lg mt-2 text-gray-700">You're all set to start your task!</p>
    <button
      onClick={() => { window.location.href = "/mytask"; }}
      className="mt-6 px-6 py-3 font-semibold text-white bg-green-500 hover:bg-green-600 rounded-md transition duration-300"
    >
      Continue to Your Task
    </button>
  </div>
</div>




        </>
      )}
      {paymentStatus === "PENDING" && (
        <>
         <div className="container mx-auto mt-16 pt-16 p-4 text-center">
  <div className="block md:flex items-center justify-center">
    <div className="w-full md:w-2/6 mt-5 flex justify-center p-5 container mx-auto">
      <img src={bankimg} alt="" />
    </div>
    <div className="w-full md:w-3/5 p-0 md:p-10">
      <div className="taskcontent text-center p-5 container mx-auto rounded">
        <h3 className="text-2xl font-semibold mb-4">Order ID Not Found</h3>
        <p className="mb-2">We couldn't find your order ID in our system.</p>
        <p className="text-sm text-gray-600">Please check the order ID and try again.</p>
        <p className="text-sm text-gray-600">If you continue to have issues, feel free to contact our support team.</p>
      </div>
    </div>
  </div>
  <div className="flex items-center justify-center">
    <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12"></div>
  </div>
  <button onClick={() => { window.location.href = "/mytask"; }} className="inline-block px-6 py-3 font-bold mt-16 text-lg transition duration-300 ease-in-out transform border border-transparent rounded-md shadow-md text-white bg-blue-500 hover:bg-blue-600 hover:shadow-lg">
              Try to Payment
            </button>
</div>

        </>
      )}

         {showModal && (
        <div className="fixed top-0 left-0 w-full  h-full flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <div className="bg-white mx-5 p-8 rounded-lg shadow-lg logoutpopup">
            <h6>Log Out</h6>
             <div hidden={!showForm1Loader}>
                    {/* <div className="loader"></div> */}
                    <FullScreenOverlay>
                      <CircularProgress />
                    </FullScreenOverlay>
                  </div>
            <p>
              Are you sure you want to log out? You'll need to login again
              to use the app.
            </p>
            <div className="flex justify-between logoutbtns">
              <button onClick={handleLogout2}> Cancel</button>
              <button onClick={handleLogout3}>Log Out</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
